var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { useFetcher, useResetter } from 'rest-hooks';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Dialog, Grid, IconButton, TextField } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3),
    },
    input: {
        width: "100%",
        minWidth: "400px",
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
    buttonRow: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    popupTitle: {
        flexGrow: 1,
        fontSize: "20px",
        display: "flex",
        alignItems: "center"
    }
}));
export default function EditTag(_a) {
    var { id, resource, open, setOpen, title } = _a, props = __rest(_a, ["id", "resource", "open", "setOpen", "title"]);
    const style = useStyles();
    const [name, setName] = useState('');
    const [saving, setSaving] = useState(false);
    const create = useFetcher(resource.create());
    const update = useFetcher(resource.update());
    const fetch = useFetcher(resource.detail());
    const resetCache = useResetter();
    const reload = (object) => {
        setName(object.name);
    };
    useEffect(() => {
        if (id === "new" && open === true) {
            setName("");
        }
    }, [id, open]);
    useEffect(() => {
        if (id && id !== "new") {
            fetch({ id })
                .then(reload)
                .catch(() => {
                console.error('Error');
            });
        }
    }, [id, fetch]);
    const save = () => __awaiter(this, void 0, void 0, function* () {
        setSaving(true);
        const data = {
            name
        };
        let object;
        try {
            if (id && id !== "new") {
                object = yield update({ id }, data);
            }
            else {
                object = yield create({}, data);
            }
            reload(object);
            resetCache();
            setOpen(false);
            setSaving(false);
        }
        catch (e) {
            console.error(e);
            setSaving(false);
        }
    });
    return React.createElement(Dialog, Object.assign({ open: open }, props),
        React.createElement(Box, { className: style.root },
            React.createElement(Grid, { container: true, direction: "column" },
                React.createElement(Grid, { item: true },
                    React.createElement("div", { className: style.buttonRow },
                        title && React.createElement("div", { className: style.popupTitle }, title),
                        React.createElement(IconButton, { color: "inherit", onClick: () => setOpen(false) },
                            React.createElement(CloseIcon, null)))),
                React.createElement(Grid, { item: true },
                    React.createElement("div", { className: style.form },
                        React.createElement("div", { className: style.input },
                            React.createElement(TextField, { fullWidth: true, label: "Nom", value: name, onChange: (e) => setName(e.target['value']), required: true })))),
                React.createElement(Grid, { item: true },
                    React.createElement("div", { className: style.buttonRow },
                        React.createElement(Button, { color: "inherit", onClick: save, disabled: saving }, "Sauvegarder"))))),
        "$ ");
}
//# sourceMappingURL=index.js.map